import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "bargain-wrap"
  }, [_c('Header'), _c('div', {
    staticClass: "bargain-content"
  }, [_c('img', {
    staticClass: "bargain-background",
    attrs: {
      "src": require("@/assets/images/bargain_background.png"),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "bargain-title",
    attrs: {
      "src": require("@/assets/images/bargain_title.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "head-title"
  }, [_c('span', [_vm._v("您当前的位置：")]), _c('span', {
    staticClass: "back-home",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("首页")]), _c('span', {
    staticClass: "slash"
  }, [_vm._v("/")]), _c('span', {
    staticClass: "low-title"
  }, [_vm._v("砍价低价拿")])]), _c('div', {
    staticClass: "head-img-box",
    style: _vm.bargainList.length <= 0 ? 'opacity:0' : ''
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.bargainUser, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide user-wrap"
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: item.headImage ? item.headImage : require('@/assets/images/headimg.png'),
        expression: "item.headImage ? item.headImage : require('@/assets/images/headimg.png') "
      }],
      attrs: {
        "alt": "",
        "width": "32px",
        "height": "32px"
      }
    })]), _c('span', {
      staticClass: "nick-name"
    }, [_vm._v(_vm._s(item.nickName.charAt(0)) + "***" + _vm._s(item.nickName.length > 2 ? item.nickName.charAt(item.nickName.length - 1) : ''))]), _c('span', {
      staticClass: "desc"
    }, [_vm._v("发起砍价活动")])]);
  }), 0)])]), _vm.bargainingList.length > 0 ? _c('div', {
    staticClass: "bargain-ing"
  }, [_vm._m(0), _c('ul', _vm._l(_vm.bargainingList, function (item) {
    return _c('li', {
      key: item.id
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: item.product.listImagePath ? item.product.listImagePath.cdnFilePathPc : '',
        expression: "item.product.listImagePath ? item.product.listImagePath.cdnFilePathPc : ''"
      }],
      attrs: {
        "alt": "",
        "width": "140px",
        "height": "129px"
      }
    }), _c('div', {
      staticClass: "ing-info"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(item.product.productName))]), _c('div', {
      staticClass: "product-desc"
    }, [_vm._v(_vm._s(item.product.productShortDesc))]), _c('div', {
      staticClass: "status"
    }, [item.alreadyPeople === item.totalPeople ? _c('span', {
      staticClass: "surplus"
    }, [_vm._v("恭喜，砍价成功啦")]) : _c('div', {
      staticClass: "activity-countdown"
    }, [_c('div', [_vm._v("还差"), _c('span', {
      staticClass: "surplus"
    }, [_vm._v(_vm._s(100 - (item.alreadyPeople / item.totalPeople).toFixed(2) * 100 + '%'))]), _vm._v("砍价成功")]), _c('div', {
      staticClass: "countdown"
    }, [_c('span', {
      staticClass: "hour"
    }, [_vm._v(_vm._s(item.hour))]), _vm._v(" : "), _c('span', {
      staticClass: "minute"
    }, [_vm._v(_vm._s(item.minute))]), _vm._v(" : "), _c('span', {
      staticClass: "second"
    }, [_vm._v(_vm._s(item.second))]), _c('span', {
      staticClass: "end"
    }, [_vm._v("后结束")])])])]), _c('div', {
      staticClass: "bar-wrap"
    }, [_c('span', {
      staticClass: "bar-a",
      style: {
        width: (item.alreadyPeople / item.totalPeople).toFixed(2) * 100 + '%',
        borderRadius: (item.alreadyPeople / item.totalPeople).toFixed(2) * 100 == 100 ? '3px' : '3px 0 0 3px'
      }
    }), _c('span', {
      staticClass: "bar-b",
      style: {
        width: 100 - (item.alreadyPeople / item.totalPeople).toFixed(2) * 100 + '%',
        borderRadius: 100 - (item.alreadyPeople / item.totalPeople).toFixed(2) * 100 == 100 ? '3px' : '0 3px 3px 0'
      }
    })]), _c('div', {
      staticClass: "operation"
    }, [item.alreadyPeople === item.totalPeople ? _c('span', {
      staticClass: "payment",
      on: {
        "click": function click($event) {
          return _vm.goOrderConfirm(item);
        }
      }
    }, [_vm._v("去付款")]) : _c('span', {
      staticClass: "invite",
      on: {
        "click": function click($event) {
          return _vm.openDialog(item.id);
        }
      }
    }, [_vm._v(_vm._s(item.alreadyPeople === 0 ? '邀请好友砍一刀' : '继续砍价'))])])])]);
  }), 0)]) : _vm._e(), _vm._m(1), _c('div', {
    staticClass: "head-info"
  }, [_c('ul', _vm._l(_vm.bargainList, function (item) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.$router.push("/details?id=".concat(item.id, "&configId=").concat(item.config_id, "&type=bargain&product_id=").concat(item.product_id));
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: item.proImage ? item.proImage.sourceUrl : '',
        expression: "item.proImage ? item.proImage.sourceUrl : ''"
      }],
      staticClass: "goods-img",
      attrs: {
        "alt": ""
      }
    }), _c('p', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.product_name))]), _c('p', {
      staticClass: "goods-recommend"
    }, [_vm._v(_vm._s(item.product_short_desc))]), _c('p', {
      staticClass: "original-price"
    }, [_vm._v("原价："), _c('del', {
      staticClass: "del-price"
    }, [_vm._v("￥" + _vm._s(item.lowest_price.split(',')[0]))])]), _c('div', {
      staticClass: "goods-price"
    }, [item.lowPrice ? _c('span', {
      staticClass: "activity-price"
    }, [_vm._v("￥" + _vm._s(item.lowPrice)), String(item.lowPrice).indexOf('.') === -1 ? _c('span', {
      staticClass: "decimals"
    }, [_vm._v("." + _vm._s(item.lowPrice2))]) : _vm._e()]) : _vm._e(), _c('span', {
      staticClass: "bargain-immediately"
    }, [_vm._v("立即砍价")])])]);
  }), 0)])])]), _vm.totalnumber > 15 ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageNo,
      "page-sizes": [15, 30, 60],
      "page-size": _vm.pageSize,
      "total": _vm.totalnumber,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        _vm.pageNo = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.pageNo = $event;
      },
      "size-change": function sizeChange($event) {
        return _vm.handleSizeChange($event);
      },
      "current-change": function currentChange($event) {
        return _vm.handleCurrentChange($event);
      }
    }
  })], 1) : _vm._e(), _c('Footer'), _c('el-dialog', {
    attrs: {
      "title": "邀请好友砍一刀",
      "visible": _vm.dialogVisible,
      "width": "580px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('div', {
    ref: "qrCodeUrl",
    staticClass: "qr-code"
  }), _c('div', {
    staticClass: "copy-url"
  }, [_c('span', {
    staticClass: "url"
  }, [_c('span', [_vm._v("地址：")]), _vm._v(_vm._s(_vm.qrcodeUrl) + "/m/bargaining?id=" + _vm._s(_vm.productId))]), _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: "".concat(_vm.qrcodeUrl, "/m/bargaining?id=").concat(_vm.productId),
      expression: "`${qrcodeUrl}/m/bargaining?id=${productId}`",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn"
  }, [_vm._v("复制链接")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "ing-title"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/bargain_tit1.png"),
      "alt": "",
      "width": "212px",
      "height": "20px"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "ing-title info-tit"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/bargain_tit2.png"),
      "alt": "",
      "width": "212px",
      "height": "20px"
    }
  })]);
}];
export { render, staticRenderFns };